import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back to Bank view',
    delay: 'We will process your request as soon as possible.',
    followUp:
      'You can follow the progress of your file from Help Center > Access my conversations.',
    open: 'Open my dispute',
    title: 'Dispute request sent successfully!',
  },
  fr: {
    back: 'Retourner à la vue Banque',
    delay: 'Votre demande sera traitée dans les plus brefs délais.',
    followUp:
      'Vous pouvez suivre l’avancement de votre dossier depuis Centre d’aide > Accéder à mes conversations.',
    open: 'Accéder à ma contestation',

    title: 'Demande de contestation envoyée avec succès\xa0!',
  },
} as const);

export default locales;
